import React from "react";

import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { PDPInformationSetDelivery } from "./PDPInformationSetDelivery";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";
import { usePageLocaleContext } from "../../../../global/page-context";
import type { TranslatedValue } from "@swo/storefront";

export type PDPInformationSetData = Array<{
  IconComponent: React.FunctionComponent;
  label: TranslatedValue;
}>;

export const PDPInformationSet: ReactTFC<{
  informationSetDeliveryData: PDPInformationSetData;
}> = props => {
  const { locale } = usePageLocaleContext();
  const isCartFeatureActive = locale.shopMode.cart === "enabled";

  return (
    <>
      {isCartFeatureActive ? (
        <PDPInformationSetDelivery elements={props.informationSetDeliveryData} />
      ) : (
        <hr
          css={css`
            border: none;
            border-top: 1px solid ${CSS_COLORS.Grey5};
            height: 0;
          `}
        />
      )}
    </>
  );
};
